import { escape } from "./regexp";
import { isDefined } from "./utils";

export function getUniqueName<T>(items: T[], property: string, baseName: string): string {

    let max: number = 0;

    let regex = new RegExp("^\\s*" + escape(baseName) + "\\s*([-#\(]?\\s*(\\d+)\\s*\\)?)?\\s*$", "i");

    items.forEach(i => {

        var match = regex.exec(i[property]);

        if (match) {

            var index = 2;

            if (isDefined(match[2])) {
                index = 1 + parseInt(match[2]);
            }

            max = Math.max(max, index);

        }

    });

    return baseName + (max ? " (" + max + ")" : "");

}

export function getBaseName(name: string): string {

    let regex = new RegExp("^\\s*(.+?)\\s([-#\(]?\\s*(\\d+)\\s*\\)?)\\s*$", "i");

    let match = regex.exec(name);

    if (match) {
        return match[1];
    }

    return name;

}

export function validateUniqueName<T>(name: string, items: T[], nameSelector: (item: T) => string, filter?: (item: T) => boolean) {

    if (!items) return true;
    if (filter) items = items.filter(i => filter(i));

    name = (name || "").toLocaleLowerCase();

    return items.every(i => {

        var itemName = (nameSelector(i) || "").toLocaleLowerCase();

        return itemName != name;

    });

}
